import { generatePostEndpoint } from "src/api/@utils";
// import { baseURL as rootURL } from "..";

// THIS IS A BAD WAY TO DO THIS BUT IS THE CURRENT WORKAROUND DUE TO CIRCULAR DEPENDENCY ISSUES
const baseURL = "/inventory" + "/item" + "/create"

const useInventoryItemCreateEndpoints = () => {
    const many = generatePostEndpoint<{items: Array<any>}, string>(baseURL + "/many");
    const parseSheet = generatePostEndpoint<FormData, Array<any>>(baseURL + "/parse-sheet");
    const single = generatePostEndpoint<{item: any}, string>(baseURL + "/single");

    return {
        many,
        parseSheet,
        single,
    }
}

export {
    baseURL,
    useInventoryItemCreateEndpoints
};